import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledSongPlayer = styled.div`
  width: 100%;
  height: ${({ showControls }) => (showControls ? '60px' : '0')};
  position: relative;
  .player-wrapper {
    position: relative;
    height: 66px;
  }

  .player-controls {
    background-color: ${Colors.playerControlsThemes.inverted.background};

    &:hover {
      background-color: ${Colors.playerControlsThemes.inverted.background};
    }
  }
`;
